import { Scene } from "../../interfaces/Interfaces";
import axios from "axios";

const baseUrl: string = process.env.VUE_APP_API_BASE_URL

const state = {
  scenes: []
}

const getters = {
  getScenes: (state: any): Scene[] | [] => {
    return state.scenes
  }
}

const actions = {
  fetchScenes({commit}: any) {
    axios.get(`${baseUrl}/stimulus-scenes`)
    .then(res=> {
      commit('setScenes', res.data)
    })
    .catch(err => {
      throw err
    })
  },
  addScene({ commit }: any, newScene: Scene) {
    axios({
      method: 'post',
      headers: {'Content-Type': 'application/json'},
      url: `${baseUrl}/stimulus-scenes/`,
      data: JSON.stringify(newScene)
    })
    .then(res => {
      const scene: Scene = res.data
      commit('addScene', scene)
    })
    .catch(err => {
      throw err
    })
  },
  updateScene({ commit }: any, updatedScene: Scene) {
    axios({
      method: 'put',
      url: `${baseUrl}/stimulus-scenes/${updatedScene.id}`,
      data: updatedScene
    })
    .then(res => {
      const scene: Scene = res.data
      commit('updateScene', scene)
    })
    .catch(err => {
      throw err
    })
  },
  deleteScene({commit}: any, sceneId: number) {
    axios({
      method: 'delete',
      url: `${baseUrl}/stimulus-scenes/${sceneId}`
    })
    .then(() => {
      commit('deleteScene', sceneId)
    })
    .catch(err => {
      throw err
    })
  }
}

const mutations = {
  setScenes: (state: any, scenes: Scene[]): void => {
    if (scenes) scenes.sort((a,b) => a.start - b.start)
    state.scenes = scenes
  },
  addScene: (state: any, scene: Scene): void => {
    const newArray = [...state.scenes, scene]
    newArray.sort((a, b) => a.start - b.start)
    state.scenes = newArray
  },
  deleteScene: (state: any, sceneId: number): Scene[] | [] => state.scenes = state.scenes.filter((s: Scene) => s.id !== sceneId),
  updateScene: (state: any, scene: Scene): void => {
    const index = state.scenes.findIndex((s: Scene) => s.id === scene.id)
    if (index !== -1) {
      state.scenes.splice(index, 1, scene)
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
